import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { statApi } from '../../../api/statApi.js';
import { NavBar } from '../../app/navBar.js';
import './statScreen.css';  // Import the CSS file

function StatScreen() {
    const [topLocations, setTopLocations] = useState([]);
    const [bottomLocations, setBottomLocations] = useState([]);
    const [topPage, setTopPage] = useState(1);
    const [bottomPage, setBottomPage] = useState(1);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchTopLocations = async (page) => {
        try {
            const response = await statApi.getLocations("DESC", 10, page);
            setTopLocations(response.data.rows);
        } catch (err) {
            setError(err.message || "An error occurred fetching top locations.");
        }
    };

    const fetchBottomLocations = async (page) => {
        try {
            const response = await statApi.getLocations("ASC", 10, page);
            setBottomLocations(response.data.rows);
        } catch (err) {
            setError(err.message || "An error occurred fetching bottom locations.");
        }
    };

    useEffect(() => {
        fetchTopLocations(topPage);
        fetchBottomLocations(bottomPage);
    }, [topPage, bottomPage]);

    const handleLocationClick = async (location) => {
        try {
            const response = await statApi.getLocationID(location);
            const imageID = response.data.id;

            // Check if the imageID is valid
            if (imageID === 0 || imageID === -1) {
                setError("Invalid location ID. Unable to navigate.");
            } else {
                // Navigate to the details page with the image ID
                navigate(`/details/${imageID}`);
            }
        } catch (err) {
            setError("An error occurred while fetching the location ID.");
        }
    };

    const handleTopPageChange = (direction) => {
        if (direction === 'prev' && topPage > 1) {
            setTopPage(topPage - 1);
        } else if (direction === 'next') {
            setTopPage(topPage + 1);
        }
    };

    const handleBottomPageChange = (direction) => {
        if (direction === 'prev' && bottomPage > 1) {
            setBottomPage(bottomPage - 1);
        } else if (direction === 'next') {
            setBottomPage(bottomPage + 1);
        }
    };

    return (
        <div className="stat-screen">
            <NavBar />
            <h2 className="stat-title">Stats</h2>

            {error && <p className="error-message">{error}</p>}

            <div className="locations-container">
                {/* Top Locations */}
                <div className="locations-box">
                    <h3 className="locations-title">Top Locations</h3>
                    <ul className="locations-list">
                        {Array.isArray(topLocations) && topLocations.map((location, index) => (
                            <li key={index} className="location-item">
                                <div
                                    className="location-box"
                                    onClick={() => navigate(`/albums/dynamic?location=${encodeURIComponent(location.location)}`)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {location.location} <span className="count">{location.count}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="pagination-controls">
                        <button 
                            className="pagination-arrow"
                            onClick={() => handleTopPageChange('prev')}
                            disabled={topPage === 1}
                        >
                            ←
                        </button>
                        <span className="page-number">Page {topPage}</span>
                        <button 
                            className="pagination-arrow"
                            onClick={() => handleTopPageChange('next')}
                        >
                            →
                        </button>
                    </div>
                </div>

                {/* Bottom Locations */}
                <div className="locations-box">
                    <h3 className="locations-title">Bottom Locations</h3>
                    <ul className="locations-list">
                        {Array.isArray(bottomLocations) && bottomLocations.map((location, index) => (
                            <li key={index} className="location-item">
                                <div
                                    className="location-box"
                                    onClick={() => handleLocationClick(location.location)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {location.location} <span className="count">{location.count}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="pagination-controls">
                        <button 
                            className="pagination-arrow"
                            onClick={() => handleBottomPageChange('prev')}
                            disabled={bottomPage === 1}
                        >
                            ←
                        </button>
                        <span className="page-number">Page {bottomPage}</span>
                        <button 
                            className="pagination-arrow"
                            onClick={() => handleBottomPageChange('next')}
                        >
                            →
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { StatScreen };
